// extracted by mini-css-extract-plugin
export var container = "styles-module__container___pQYDf";
export var opacCover = "styles-module__opacCover___W32RU";
export var img = "styles-module__img___Z37vq";
export var title = "styles-module__title___Y6ysD";